import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import {useCurrentState} from "../globalState";

function TopAppBar(props) {
    let [ref, setRef] = useState(null);
    let [_, setCurrentDialogAppBarWidth] = useCurrentState("currentDialogAppBarWidth");
    useEffect(() => {
        if (ref) {
            setCurrentDialogAppBarWidth(ref.clientHeight);
        }
    }, [ref]);
    return <AppBar innerRef={setRef} position={'fixed'}>
        <Toolbar>
            <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="Close">
                <Icon>close</Icon>
            </IconButton>
            <Typography style={{
                marginLeft: 10,
                flex: 1,
            }} color="inherit" variant="h6">
                {props.title}
            </Typography>
            {props.go}
        </Toolbar>
    </AppBar>;
}


class ResponsiveDialog extends React.Component {
    state = {
        open: false,
    };

    handleClickOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.setState({open: false});
    };

    componentDidMount() {
        this.props.api(this.handleClickOpen, this.handleClose);
    }

    handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.handleClose();
    };

    render() {
        const {fullScreen} = this.props;

        let go = <Button disabled={this.props.actionButtonDisabled} onClick={() => {
            let res = this.props.action();
            if (res && res.then) {
                res.then(() => this.handleClose());
            } else {
                this.handleClose();
            }
        }} color="inherit" autoFocus>
            {this.props.actionText}
        </Button>;

        return (
            <div>
                <Dialog
                    PaperProps={{
                        style: {maxWidth: 1024}
                    }}
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    {window.innerWidth <= 1024 && false ?
                        <TopAppBar go={go} title={this.props.title} handleClose={this.handleClose}/> : null}

                    {this.props.title ? <DialogTitle>{this.props.title}</DialogTitle> : null}
                    <div>
                        {this.props.children}
                    </div>
                    {true ? <DialogActions>
                        <Button onClick={this.handleCancel} color="primary">
                            {this.props.cancelText}
                        </Button>
                        {go}
                    </DialogActions> : null}
                </Dialog>
            </div>
        );
    }
}

ResponsiveDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(ResponsiveDialog);
